import React, { FC } from 'react';
import classNames from 'classnames';
import { FileThumb, Hyperlink } from '@fx-ui/jdy-design-biz';
import { get, isEmpty, parseFileName } from '~/utils';
import Intl from '@fx-ui/intl';
import { MAX_OFFICE_VIEW_SIZE, helpSourceIntl } from '~/constants';

const IMode = {
    TYPE: 'type',
    SIZE: 'size'
} as const;

type IUnSupportMode = (typeof IMode)[keyof typeof IMode];
interface IUnSupportFilePreview {
    className?: string;
    file: { name: string };
    mode?: IUnSupportMode;
    tip?: string;
}

const UnSupportFilePreview: FC<IUnSupportFilePreview> = ({
    file,
    mode = IMode.TYPE,
    tip,
    className
}) => {
    const [, extName] = parseFileName(get(file, 'name'));

    const getTip = () => {
        if (!isEmpty(tip)) {
            return tip;
        }
        if (mode === IMode.TYPE) {
            return Intl.get('file.preview.noSupport');
        }
        return Intl.get('file.preview.noSupport.size', { num: MAX_OFFICE_VIEW_SIZE / 1024 / 1024 });
    };

    return (
        <div className={classNames('fx-unsupport-file-preview', className)}>
            <FileThumb className="other-thumb" ext={extName} />
            <div className="preview-file-tip">{getTip()}</div>
            {mode === IMode.TYPE && (
                <Hyperlink
                    compact
                    href={helpSourceIntl.get('doc_un_support_file')}
                    className="preview-file-link"
                >
                    {Intl.get('file.preview.support')}
                </Hyperlink>
            )}
        </div>
    );
};

export default UnSupportFilePreview;
